import { createActions } from '../utils/actions';

const { actions: scheduledUpdates } = createActions('scheduledUpdates')
  .add('bootstrap')
  .add('cleanUp')
  .addAsync('deleteUpdates')
  .addAsync('getNextScheduled')
  .addAsync('loadUpdates')
  .add('setPage')
  .add('setStatus')
  .add('showSyncModal')
  .add('toggleUpdate');

export default scheduledUpdates;
